import React from 'react';
import '../styles/footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <p>&copy; Copyright 2021 Johannes de Vries</p>
    </div>
  );
};

export default Footer;
